import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { motion } from "framer-motion";

import Links from "./helper/links";

const Hero = ({ loading }) => {
  return (
    <>
      <div className="mt-24 bg-bg1 relative flex sm:h-b  h-96 ">
        <motion.div
          variants={headingText}
          initial="initial"
          animate={loading ? "initial" : "animate"}
          className="text-white flex flex-col relative text-6xl  sm:text-7xl md:text-8xl lg:text-10xl  tracking- sm:tracking-wide leading-5 space-y-20 sm:space-y-28 mt-20  sm:mt-28 sm:ml-7 lg:ml-20 font-prime "
        >
          <div className="    z-10 padding mix-blend-difference ">I am </div>
          <div className="    z-10 padding mix-blend-difference "> front-end </div>
          <div className="    z-10 padding mix-blend-difference ">developer</div>
        </motion.div>
        <motion.div
          variants={picture}
          initial="initial"
          animate={loading ? "initial" : "animate"}
          className="absolute flex    flex-grow-0 w-2/3 sm:w-3/5 lg:w-2/5   max-w-3xl right-0 top-0 lg:mr-16   padding"
        >
          <StaticImage src="../images/pic1.png" placeholder="blurred" alt="Hero Picture" />
        </motion.div>
      </div>
      <div>
        <div className="flex relative padding space-x-4 font-advent  tracking-widest underline text-text1">
          <motion.div
            variants={variants}
            initial="initial"
            animate={loading ? "initial" : "animate"}
            className="bg-bg1 w-screen h-10 absolute top-0"
          ></motion.div>
          <Links />
        </div>
        <motion.div
          variants={arrow}
          initial="initial"
          animate="animate"
          className="mt-10 sm:flex justify-self-center content-center self-center place-content-center items-center justify-center    justify-items-cente hidden sm:block"
        >
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 3.8 }}>
            <StaticImage src="../images/arrow.png" width="30" placeholder="blurred" alt="Hero Picture" />
          </motion.div>
        </motion.div>
      </div>
    </>
  );
};
const arrow = {
  animate: { y: [0, 15, 0], opacity: 1, transition: { repeat: 2, duration: 2, delay: 4 }, exit: { opacity: 0 } },
};
const picture = {
  initial: { opacity: 0, y: -30 },
  animate: {
    opacity: 1,
    y: 0,
    filter: ["contrast(20%)", "contrast(900%)", "contrast(100%)"],
    // filter: "contrast(100%)",
    transition: { duration: 2.5, delay: 0, times: [0.1, 0.5, 0.9] },
  },
};

const headingText = {
  initial: { opacity: 0, bottom: -50 },
  animate: {
    opacity: 1,

    bottom: 0,
    transition: { duration: 1.2, delay: 0.8 },
  },
};

const variants = {
  initial: { width: "100%" },
  animate: {
    width: "0%",
    transition: {
      duration: 2.5,
      delay: 0.2,
    },
  },
};
export default Hero;
